import { render, staticRenderFns } from "./TakeSelfie.vue?vue&type=template&id=f95dc5d4&scoped=true&"
import script from "./TakeSelfie.ts?vue&type=script&lang=ts&"
export * from "./TakeSelfie.ts?vue&type=script&lang=ts&"
import style0 from "./TakeSelfie.scss?vue&type=style&index=0&id=f95dc5d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95dc5d4",
  null
  
)

export default component.exports